var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0001 14.2651C10.6728 14.2651 13.6501 11.2878 13.6501 7.61509C13.6501 3.94239 10.6728 0.965088 7.0001 0.965088C3.3274 0.965088 0.350098 3.94239 0.350098 7.61509C0.350098 11.2878 3.3274 14.2651 7.0001 14.2651ZM7.63661 8.25144H10.8184C11.1684 8.25144 11.4548 7.96508 11.4548 7.61508C11.4548 7.26508 11.1684 6.97872 10.8184 6.97872H7.63661V3.7969C7.63661 3.4469 7.35024 3.16054 7.00024 3.16054C6.65024 3.16054 6.36388 3.4469 6.36388 3.7969V6.97872H3.18206C2.83206 6.97872 2.5457 7.26508 2.5457 7.61508C2.5457 7.96508 2.83206 8.25144 3.18206 8.25144H6.36388V11.4333C6.36388 11.7833 6.65024 12.0696 7.00024 12.0696C7.35024 12.0696 7.63661 11.7833 7.63661 11.4333V8.25144Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusIcon);
export default __webpack_public_path__ + "static/media/AddPlusIcon.ba0fda0bcf5800b32f2074aedc192145.svg";
export { ForwardRef as ReactComponent };